import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
// Note: Firestore (db) is NOT exported - all database operations MUST go through Cloud Functions
// import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  ...(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    ? { measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID }
    : {}),
};

// Debug: Log Firebase config (temporary)
// console.log('🔥 Firebase config debug:', {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY ? '✅ Present' : '❌ Missing',
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ? '✅ Present' : '❌ Missing',
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ? '✅ Present' : '❌ Missing',
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ? '✅ Present' : '❌ Missing',
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
//     ? '✅ Present'
//     : '❌ Missing',
//   appId: process.env.REACT_APP_FIREBASE_APP_ID ? '✅ Present' : '❌ Missing',
// });

// console.log('🔥 Full Firebase config:', firebaseConfig);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
// SECURITY: db (Firestore) is NOT exported - all database operations MUST go through Cloud Functions
// This prevents accidental direct database access from the frontend
// export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const storage = getStorage(app);

// Connect to emulators in development
if (process.env.NODE_ENV === 'development') {
  // Development mode: Use deployed services, not local emulators
  // console.log('🔥 Using deployed Firebase services (development project)');
}

export default app;
